import React, { useState } from "react";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Tooltip,
} from "@mui/material";
import { Grid } from "@material-ui/core";
import AppsIcon from "@mui/icons-material/Apps";
import googleMeet from "../../assets/images/googleMeet.png";

const apps = [
  {
    name: "Account",
    icon: "https://www.gstatic.com/images/branding/product/1x/avatar_circle_blue_512dp.png",
    link: "https://myaccount.google.com/",
  },
  {
    name: "Gmail",
    icon: "https://ssl.gstatic.com/ui/v1/icons/mail/rfr/gmail.ico",
    link: "https://mail.google.com",
  },
  {
    name: "Drive",
    icon: "https://ssl.gstatic.com/images/branding/product/1x/drive_2020q4_48dp.png",
    link: "https://drive.google.com",
  },
  {
    name: "Gemini",
    icon: "https://www.gstatic.com/images/branding/product/2x/gemini_48dp.png",
    link: "https://gemini.google.com",
  },
  {
    name: "Docs",
    icon: "https://ssl.gstatic.com/docs/documents/images/kix-favicon7.ico",
    link: "https://docs.google.com",
  },
  {
    name: "Sheets",
    icon: "https://www.gstatic.com/images/branding/product/2x/sheets_2020q4_48dp.png",
    link: "https://sheets.google.com",
  },
  {
    name: "Slides",
    icon: "https://www.gstatic.com/images/branding/product/2x/slides_2020q4_48dp.png",
    link: "https://slides.google.com",
  },
  {
    name: "Calendar",
    icon: "https://ssl.gstatic.com/calendar/images/dynamiclogo_2020q4/calendar_18_2x.png",
    link: "https://calendar.google.com",
  },
  {
    name: "Chat",
    icon: "https://developers.google.com/chat/images/chat-product-icon.png",
    link: "https://chat.google.com",
  },
  {
    name: "Meet",
    icon: googleMeet,
    link: "https://meet.google.com",
  },
  {
    name: "Forms",
    icon: "https://www.gstatic.com/images/branding/product/2x/forms_48dp.png",
    link: "https://forms.google.com",
  },
  {
    name: "Sites",
    icon: "https://www.gstatic.com/images/branding/product/2x/sites_2020q4_48dp.png",
    link: "https://sites.google.com",
  },
  {
    name: "Contacts",
    icon: "https://www.gstatic.com/images/branding/product/2x/contacts_2022_48dp.png",
    link: "https://contacts.google.com/",
  },
];

const GoogleAppsMenu: React.FC = () => {
  const [googleAppOpen, setGoogleAppOpen] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setGoogleAppOpen(event.currentTarget);
  };

  const handleClose = () => {
    setGoogleAppOpen(null);
  };

  return (
    <>
      <Tooltip title="Google Apps">
        <IconButton color="inherit" onClick={handleOpen}>
          <AppsIcon />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={googleAppOpen}
        open={Boolean(googleAppOpen)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            backgroundColor: "#202124",
            color: "#fff",
            borderRadius: "16px",
            padding: "0px 12px",
            width: 250,
            maxHeight: 400,
            overflowY: "auto",
            boxShadow:
              "0 -1px 2px 0 rgba(0,0,0,.3),0 -2px 6px 2px rgba(0,0,0,.15)",
            border: "10px solid #282a2c",
          },
        }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Grid container spacing={2}>
          {apps.map((app) => (
            <Grid item xs={4} key={app.name}>
              <MenuItem
                onClick={handleClose}
                component="a"
                href={app.link}
                target="_blank"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  borderRadius: 2,
                  padding: 1,
                  "&:hover": {
                    backgroundColor: "#303134",
                  },
                }}
              >
                <Box
                  component="img"
                  src={app.icon}
                  alt={app.name}
                  sx={{
                    width: 40,
                    height: 40,
                    mb: 1,
                    objectFit: "contain",
                    borderRadius: app.name === "Account" ? "50%" : "4px",
                  }}
                />
                <Typography
                  variant="caption"
                  sx={{
                    color: "#e8eaed",
                    fontSize: "0.75rem",
                    textTransform: "none",
                    lineHeight: 1.2,
                  }}
                >
                  {app.name}
                </Typography>
              </MenuItem>
            </Grid>
          ))}
        </Grid>
      </Menu>
    </>
  );
};

export default GoogleAppsMenu;
